import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd-next';
import { Row, Col, Button, Input } from 'reactstrap';
import leftarrow from "assets/icon/QualificationLeftArrow.svg";
import rightarrow from "assets/icon/QualificationRightArrow.svg";
import leftbackward from "assets/icon/QualificationDoubleLeftArrow.svg";
import rightforward from "assets/icon/QualificationDoubleArrowRight.svg";
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import Confirm from 'components/Confirm';
import { toast } from 'react-toastify';
import Loader from 'components/Loader';
import save from "assets/icon/save.svg";



let selcolumndata = [];
let autoselectlist = [];
let ids = [];
let roleids = []
const DragDrop = (props) => {

    //  let clm = module;
    const API = useAxios();
    const { cancalcolselect, refetch, reloadautocolumn, module } = props;

    useEffect(() => {
        handlAutoColumns();
        roleids = [];
    }, []);
    useEffect(() => {
        handleSelectColumns();
    }, []);
    const [activeids, setActiveids] = useState([]);
    const [activeId, setActiveId] = useState(-1);
    const [box, setBox] = useState([]);

    const [box1, setBox1] = useState([]);
    const [isConfirm, setConfirm] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleSelectColumns = async () => {
        
        setBox1([]);
        selcolumndata = [];
        let datacol = {}
        try {
            datacol = await API.get(`CPConfig/ColumnSelector/columnslist/${module}`, {
                hasDefaultURL: true,
            });

            if (datacol.data) {
                for (var x in datacol.data) {
                    selcolumndata.push({ "id": datacol.data[x].gridColumnsID, "title": datacol.data[x].displayName, "index": datacol.data[x].displayOrder })
                    setBox1(selcolumndata);
                }
                setActiveids([]);
            }
        } catch (err) {
            setActiveids([]);
        }
    };

    const handleOnDragEnd = (result) => {

        if (result.destination) {
            const newBox = Array.from(box);
            const [draggedItem] = newBox.splice(result.source.index, 1);
            newBox.splice(result.destination.index, 0, draggedItem);
            var iCount = 0;
            for (var x in newBox) {
                newBox[x].index = iCount;
                iCount += 1;
            }
            setBox(newBox);
            console.log(box);
        }
    }

    // const handleLeftClick = (id) => {
    //     setActiveId(id);
    // }

    // const handleRightClick = (id) => {
    //     setActiveId(id);
    // }

    const handleRight = () => {
        
        ids = [];
        if (activeids.length > 0) {
            let mainData1 = box1.filter((list) => activeids.includes(list.id));
            if (mainData1.length > 0) {
                var boxLength = box.length;
                for (var x in mainData1) {
                    // ids.push({ "id": mainData1[x].id, "title": mainData1[x].title, "index": box.length + 1 });
                    boxLength += 1;
                    ids.push({ "id": mainData1[x].id, "title": mainData1[x].title, "index": boxLength });
                }
                var item1 = [...box, ...ids];
                setBox(item1);
                let mainDataAfterMove1 = box1.filter((list) => !activeids.includes(list.id));
                setBox1(mainDataAfterMove1);
                setActiveids([]);
                roleids = [];

            }
        }
        // else {
        //     let mainData = box1.filter((list) => list.id === activeId);
        //     if (mainData.length > 0) {
        //         var item = {};
        //         item.id = mainData[0].id;
        //         item.title = mainData[0].title;
        //         item.index = box.length + 1;
        //         var item1 = [...box, item];
        //         setBox(item1);
        //         let mainDataAfterMove = box1.filter((list) => list.id !== activeId);
        //         setBox1(mainDataAfterMove);
        //         setActiveId(-1);

        //     }
        // }

    }

    const handlAutoColumns = async () => {

        autoselectlist = [];
        setLoading(true);

        try {
            const { data } = await API.get(`CPConfig/ColumnSelector/autoselectcolumnslist/${module}`, {
                hasDefaultURL: true,
            });
            if (data.length > 0) {
                for (var x in data) {
                    autoselectlist.push({ "id": data[x].gridColumnsID, "title": data[x].displayName, "index": data[x].displayOrder });
                    setBox(autoselectlist);
                }
                setActiveids([]);
                setLoading(false);
            }
            else {
                setBox([]);
                setActiveids([]);
                setLoading(false);
            }


        } catch (err) {
            setLoading(false);
        }
    }


    const handlesave = async () => {
        
        handleSaveConfirmation();
        let payload = box;
        setLoading(true);
        try {
            const { data } = await API.post(`CPConfig/ColumnSelector/selectcolumnslist/${module}`, payload, {
                hasDefaultURL: true,
            });
            if (data) {
                toast.success("Columns Saved Successfully");
                cancalcolselect();
                reloadautocolumn();
                // refetch();
                setLoading(false);
            }
            else {
                setLoading(false);
            }


        } catch (err) {
            setLoading(false);
        }
    }


    const handleLeft = () => {

        ids = [];
        if (activeids.length > 0) {
            let mainData = box.filter((list) => activeids.includes(list.id));
            if (mainData.length > 0) {
                var boxLength = box.length;
                for (var x in mainData) {
                    // ids.push({ "id": mainData[x].id, "title": mainData[x].title, "index": box.length + 1 });
                    boxLength += 1;
                    ids.push({ "id": mainData[x].id, "title": mainData[x].title, "index": boxLength });
                }
                var item1 = [...box1, ...ids];
                setBox1(item1);
                let mainDataAfterMove = box.filter((list) => !activeids.includes(list.id));
                setBox(mainDataAfterMove);
                setActiveids([]);
                roleids = [];
            }
        }
        else {
            let mainData = box.filter((list) => list.id === activeId);
            if (mainData.length > 0) {
                var item = {};
                item.id = mainData[0].id;
                item.title = mainData[0].title;
                item.index = box1.length + 1;
                var item1 = [...box1, item];
                setBox1(item1);

                let mainDataAfterMove = box.filter((list) => list.id !== activeId);
                setBox(mainDataAfterMove);
                setActiveids([]);
                roleids = [];
            }
        }

    }

    const handleAllRight = () => {
        
        if (box1.length > 0) {
            if (box.length > 0) {
                var ids = []
                for (var x in box1) {
                    ids.push(
                        { "id": box1[x].id, "title": box1[x].title, "index": box.length + 1 })
                }
                var item1 = [...box, ...ids];
                setBox(item1);
                setBox1([]);
            }
            else {
                var item1 = [...box, ...box1];
                setBox(item1);
                setBox1([]);
            }

        }
    }

    const handleAllLeft = () => {
        if (box.length > 0) {
            var item1 = [...box1, ...box];
            setBox1(item1);
            setBox([]);
        }
    }

    const handleSaveConfirmation = () => {
        
        setConfirm(!isConfirm)
    }
    const reset = () => {
        handlAutoColumns();
        handleSelectColumns();
    }
    const onChange = (e, id) => {

        var check = e.target.checked;

        if (check == true) {
            setActiveids([]);
            roleids.push(id);
            setActiveids(roleids)
        }
        else {
            if (roleids.length > 0) {
                let index = roleids.indexOf(id);
                roleids.splice(index, 1);
                setActiveids(roleids);
            }
        }
        // if (!activeids.includes(id)) {
        //     setActiveids([]);
        //     roleids.push(id);
        //     setActiveids(roleids)
        // }
        // else {
        //     if(roleids.length>0)
        //     {
        //         roleids.pop(id);
        //        setActiveids(roleids);
        //     }

        // }

    }
    const renderCheckbox = (id, title, index) => {

        //const filter = activeids.filter((item) => item === id);
        return (
            <Input
                onChange={(e) => onChange(e, id)}
                type='checkbox'
                className='me-2 mt-0 form-check-input'
            //  value={filter.length > 0}
            //  checked={filter.length > 0}
            />);
    }
    return (
        <div className='picker_info'>
            {loading && <Loader opacity={0.01} colour='black' />}
            <Row>
                <Col md={5}>
                    <div>

                        <h3>Available Columns</h3>
                        <ul>
                            {box1.map(({ id, title }, index) =>
                                <li key={id} ><div className="box d-flex "><span className="d-flex align-items-start" style={{ paddingTop: "5px" }}>{renderCheckbox(id, title, index)}</span>{title}</div></li>)}
                        </ul>
                    </div>
                </Col>
                <Col md={2}>
                    <div className='d-flex justify-content-center pt-5'>
                        <div className='icons_list mt-2'>
                            <div className='pb-3'>
                                <img src={rightarrow} alt="" width={32} onClick={handleRight} />
                            </div>
                            <div>
                                <img src={leftarrow} alt="" width={32} onClick={handleLeft} />
                            </div>
                            <div className='pt-4 pb-3'>
                                <img src={rightforward} alt="" width={32} onClick={handleAllRight} />
                            </div>
                            <div><img src={leftbackward} alt="" width={32} onClick={handleAllLeft} /></div>
                        </div>
                    </div>
                </Col>
                <Col md={5}>
                    <div>
                        <h3>Selected Columns</h3>
                        <DragDropContext onDragEnd={handleOnDragEnd}>
                            <Droppable droppableId="boxes">
                                {(provided) => (
                                    <ul ref={provided.innerRef} {...provided.droppableProps}>
                                        {box.map(({ id, title }, index) =>
                                            <Draggable key={id} draggableId={id.toString()} index={index}>
                                                {(provided) => (
                                                    <li key={id} ref={provided.innerRef} {...provided.dragHandleProps} {...provided.draggableProps}><div className="box d-flex "><span className='d-flex align-items-start' style={{ paddingTop: "5px" }}>{renderCheckbox(id, title, index)}</span>{title}</div></li>)}
                                            </Draggable>
                                        )}
                                        {provided.placeholder}
                                    </ul>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div style={{ float: 'right' }}>
                        <Button onClick={handleSaveConfirmation} className='search' color='primary'>
                        <span className="right_5">
                <img src={save} alt="" />
              </span>{" "}
              save
                            
                            
                        </Button>
                        {/* <Button onClick={cancalcolselect}>
                            Cancel
                        </Button>
                        <Button onClick={reset}>
                            Reset
                        </Button> */}
                    </div>

                </Col>

            </Row>
            <Confirm
                isOpen={isConfirm}
                //loading={loading}
                message='Are you sure you want to save?'
                onToggle={handleSaveConfirmation}
                onCancel={handleSaveConfirmation}
                onContinue={handlesave}

            />
        </div>
    );
}
export default DragDrop;